import React from "react"
import Hero from "../components/hero"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Usage from "../components/usage"
import Features from "../components/features"
import Testimonial from "../components/testimonial"
import Getstarted from "../components/GetStarted"
import wave from "../images/waves/features-wave.svg"

import "../styles/index.scss"

export default ({ data }) => (
  <Layout>
    <SEO 
      title={"Automating meeting minutes"}
      description={"MinutScript is a new and modern video communication enterprise, with an easy and accountable plugin for your video and chat conferencing platform, both on mobile and desktop devices. MinutScript is a new way of connecting people across the world, giving easy access to planning and executing your future meetings. With an installed speech-to-text converter, it is easy to edit and share your meeting minutes with MinutScript. Founded in 2020 and headquarters in Zealand, Denmark."}
    />
    <section>
      <Hero />
    </section>
    <section className="usage-section">
      <Usage
        title={"Just press record and let\nMinutScript handle the rest."}
        text={
          "Enjoy never having to write boring meeting minutes again. Our app is simple to use. Just press a button to record and MinutScript will transcribe everything. Boost productivity by focusing on your meeting."
        }
        image={data.image1.childImageSharp.fluid}
        alt={"Illustration of how simple the app is to use"}
        feather={"mic"}
      />

      <Usage
        title={"Simple to edit and share\nyour document"}
        text={
          "Never worry about how to edit and share your meeting minutes again. With the build-in editor, you can now edit your automaticly transcribed documents and easily share it with colleagues with our integrated system."
        }
        image={data.image2.childImageSharp.fluid}
        alt={"Illustration of sharing and editing meeting minutes"}
        feather={"file-text"}
      />

      <Usage
        title={"Travel back in time with our\nsearch function."}
        text={
          "Roads? Where We’re Going, We Don’t Need Roads. Search for keywords or particpants and go through past meetings with the integrated search function."
        }
        image={data.image3.childImageSharp.fluid}
        alt={"Illustration of the seaching possibility in the MinutScript app"}
        feather={"search"}
      />
    </section>

    <section className="features-parent">
      <img className={Features.waves} src={wave} alt="" style={{width:"100%"}} />
      <div className="features-wrapper">
        <Features
          title={"Online meetings"}
          feather={"video"}
          text={
            "MinutScript supports your teams favorite online meeting platform. "
          }
        />

        <Features
          title={"Identify participants"}
          feather={"users"}
          text={
            "MinutScript will automaticly identify meeting participants, and keep track of who is talking."
          }
        />

        <Features
          title={"No storing of data"}
          feather={"cloud-off"}
          text={
            "The recording of your meeting is only saved temporarily, and always deleted afterwards."
          }
        />

        <Features
          title={"Calendar integration"}
          feather={"calendar"}
          text={
            "By synchronizing MinutScript with your calendar, it will be able to retrieve relevant information prior to the meeting."
          }
        />

        <Features
          title={"Language support"}
          feather={"globe"}
          text={
            "Bonjour, Guten Tag and Hola. MinutScript is powered by Googles Speech-to-text Engine, and supports a wide variety of langauges."
          }
        />

        <Features
          title={"Broadcast minutes"}
          feather={"share"}
          text={
            "Easy to share your broadcast with participants and colleagues."
          }
        />
      </div>
    </section>

    <section>
      <Testimonial
        text={
          "''Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc augue turpis, feugiat ac iaculis quis, venenatis nec tortor. Morbi mollis magna nec tellus tristique ultrices. Donec ut magna nibh. Fusce ut risus posuere erat dictum aliquam. Donec feugiat erat sed ullamcorper ultricies. Vivamus sed est consequat, pellentesque ante et, aliquam dui.''"
        }
        image={require("../images/kathleen.jpg")}
        alt={"Profile picture of Kathleen Hamilton"}
        name={"Kathleen Hamilton"}
        job={"Associate Attorney"}
      />
    </section>

    <section>
      <Getstarted primary={true} />
    </section>
  </Layout>
)

export const illustrations = graphql`
  fragment illustrations on File {
    childImageSharp {
      fluid(fit: CONTAIN) {
        ...GatsbyImageSharpFluid
      }
    }
  }
`

export const query = graphql`
  query {
    image1: file(relativePath: { eq: "images/record-illustration.png" }) {
      ...illustrations
    }
    image2: file(relativePath: { eq: "images/share-illustration.png" }) {
      ...illustrations
    }
    image3: file(relativePath: { eq: "images/search-illustration.png" }) {
      ...illustrations
    }
  }
`
